export function OutlineExclamationTriangleIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1376 5.08405L3.30827 16.9141C2.47401 18.3595 3.51683 20.1686 5.18535 20.1686H18.8439C20.5125 20.1686 21.5553 18.3595 20.721 16.9141L13.8917 5.08405C13.0575 3.63865 10.9718 3.63865 10.1327 5.08405H10.1376Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0146 9.05078V13.0911"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0146 17.1559V17.1074"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
